import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { delay, put, fork, take, race, cancel, call, select } from '@redux-saga/core/effects';
import ddt from '@wix/da-ddt';
import { createAction } from 'redux-actions';
import { isApiError, request } from '../xhr';
import { cancelFetchForStream, fetchFailure, markAsCancelled, markAsFetching } from './base/actions';
import { getStreamType } from './base/selectors';
import * as offsetActions from './withOffset/actions';
import * as cursorActions from './withCursor/actions';
import { StreamType } from './types';
const logger = ddt.createLogger('streamHelpers');
export function getActionsForStreamType(type) {
    switch(type){
        case StreamType.WITH_OFFSET:
            return offsetActions;
        case StreamType.WITH_CURSOR:
            return cursorActions;
        default:
            return {};
    }
}
export const createCallbackActionCreator = (actionType)=>createAction(actionType, (streamId)=>({
            streamId
        }));
/** @deprecated use takeStreamFetch */ export function* throttleFetchingTask(streamId, throttleMs) {
    yield delay(throttleMs);
    yield put(markAsFetching(streamId));
}
/** Listens for fetch actions for a stream. If further actions come for the
 * same stream while there is a fetch already in progress, it discards them.
 * Also allows for canceling of any streams it is handling via cancelFetchForStream */ export const takeStreamFetch = (patternOrChannel, handler, ...args)=>fork(function*() {
        const forks = {};
        while(true){
            const { fetchAction , cancelAction  } = yield race({
                fetchAction: take(patternOrChannel),
                cancelAction: take(cancelFetchForStream)
            });
            if (cancelAction) {
                const streamId = cancelAction.payload.streamId;
                const task = forks[streamId];
                if (task) {
                    yield cancel(task);
                    yield put(markAsCancelled(streamId));
                }
            }
            if (fetchAction) {
                const streamId1 = fetchAction.payload.streamId;
                if (forks[streamId1] && forks[streamId1].isRunning()) {
                    return;
                }
                forks[streamId1] = yield fork(handler, ...args.concat(fetchAction));
            }
        }
    });
function getFetchSuccessActionForDirection(actions, direction) {
    switch(direction){
        case 'all':
            return actions.fetchAllSuccess;
        case 'prev':
            return actions.fetchPreviousSuccess;
        case 'next':
        default:
            return actions.fetchSuccess;
    }
}
/** Helper to do the fetching stuff right. Use in combination with takeStreamFetch. */ export function* fetchStreamContents({ streamId , url , baseURL , direction ='next' , params , getStreamData , onSuccess , onFailure  }) {
    try {
        logger.log('Fetching stream', streamId, params);
        const result = yield call(request, {
            method: 'get',
            url,
            baseURL,
            params,
            enableCancellation: true
        });
        if (!result || isApiError(result)) {
            logger.error('Error response', streamId, result);
            yield put(fetchFailure({
                streamId,
                errorMsg: result ? result.error : 'Failed to fetch...'
            }));
            onFailure && onFailure(result);
            return;
        }
        const streamType = yield select(getStreamType, streamId);
        const actions = getActionsForStreamType(streamType);
        const fetchSuccess = getFetchSuccessActionForDirection(actions, direction);
        if (!fetchSuccess) {
            return;
        }
        logger.log('Successful fetch', streamId, result);
        yield put(fetchSuccess(_object_spread({
            streamId
        }, getStreamData(result))));
        onSuccess && onSuccess(result);
    } catch (e) {
        logger.error('Error caught while fetching', e);
        yield put(fetchFailure({
            streamId,
            errorMsg: 'Failed to fetch...'
        }));
        onFailure && onFailure();
    }
}
